import { useProductGroups } from "../../../../modules/productGroups/hooks/useProductGroups";
import { WrapperModalProductGroups } from "../../../../modules/productGroups/ui/styled";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { Button, Col, Typography } from "antd";

import {
  selectProductGroupForUpdate,
  selectIsUpdateProductGroup,
  selectModalProductGroups,
} from "../../../../redux";
import { InputSelect, InputText } from "../inputs";

const { Title } = Typography;

interface ProductGroup {
  id?: number;
  name: string;
  description?: string;
  active: boolean;
}

export const ModalProductGroups = () => {
  const modalProductGroups = useSelector(selectModalProductGroups);
  const isUpdateProductGroup = useSelector(selectIsUpdateProductGroup);
  const updateProductGroup = useSelector(selectProductGroupForUpdate);

  const {
    createProductGroup,
    updateProductGroup: updateProductGroupMutation,
    changeModalProductGroupsState,
    productGroupForUpdate,
    isLoading,
    onSubmitCreate,
    onSubmitUpdate,
  } = useProductGroups();

  const { control, handleSubmit: onSubmit } = useFormContext<ProductGroup>();

  const onSubmitCreateOrUpdate = (data: ProductGroup) => {
    if (isUpdateProductGroup) {
      onSubmitUpdate(data);
    } else {
      onSubmitCreate(data);
    }
  };

  return (
    <WrapperModalProductGroups
      title={
        isUpdateProductGroup
          ? `Actualizando grupo: '${productGroupForUpdate?.name}'`
          : `Creando grupo de productos`
      }
      open={modalProductGroups}
      width={"400px"}
      destroyOnClose
      onClose={changeModalProductGroupsState}
    >
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Nombre:
        </Title>
        <InputText placeHolder="Lomo Fino" name="name" control={control} />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          padding: 5,
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Estado:
        </Title>
        <InputSelect
          name="active"
          control={control}
          dataOptions={[
            { title: "Activo", value: "true" },
            { title: "Inactivo", value: "false" },
          ]}
          label="Estado"
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          padding: 5,
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Descripción:
        </Title>
        <InputText
          placeHolder="Grupo de productos de lomo fino en diferentes presentaciones..."
          name="description"
          control={control}
          rows
        />
      </Col>
      <Button
        style={{
          width: "100%",
          marginTop: 10,
        }}
        type="primary"
        shape="round"
        size="large"
        onClick={onSubmit(onSubmitCreateOrUpdate)}
        loading={isLoading}
      >
        {isUpdateProductGroup ? "Actualizar información" : "Crear grupo"}
      </Button>
    </WrapperModalProductGroups>
  );
};
